import Alpine from '../alpine.js'

Alpine.data('crossTeamPost', ({ selectedIds, options }) => ({
  selectedId: "",
  selectedIds,
  options,
  addId (id) {
    if (this.selectedIds.indexOf(id) === -1) {
      this.selectedIds.push(id)
    }
    this.$nextTick(() => { this.selectedId = "" })
  },
  removeId (id) {
    let index = this.selectedIds.indexOf(id)

    if (index > -1) {
      this.selectedIds.splice(index, 1)
    }
  },
  nameForId (id) {
    let option = this.options.find((option) => { return option[1] === id })
    if (option) {
      return option[0]
    }
  }
}))
